export default function WhyNow() {
  const benefits = [
    {
      icon: 'ri-global-line',
      text: 'einer modernen Digitalisierungsplattform im Sport'
    },
    {
      icon: 'ri-lightbulb-line',
      text: 'einem Produkt, das jeder sofort versteht'
    },
    {
      icon: 'ri-team-line',
      text: 'einer lebendigen Community'
    },
    {
      icon: 'ri-earth-line',
      text: 'internationalen Wachstumsmöglichkeiten'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center">
            Die Digitalisierung des Sports hat gerade erst begonnen
          </h2>
          
          <p className="text-xl text-gray-700 mb-12 text-center leading-relaxed">
            Sport, Gaming und Community wachsen weltweit rasant zusammen.
            Genau hier setzt unsere Plattform an – leicht erklärbar, massentauglich und perfekt skalierbar.
          </p>

          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Du profitierst von:
          </h3>

          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className={`${benefit.icon} text-2xl text-blue-600`}></i>
                </div>
                <p className="text-lg text-gray-800 leading-relaxed pt-2">
                  {benefit.text}
                </p>
              </div>
            ))}
          </div>

          <p className="text-xl text-gray-700 text-center font-semibold bg-blue-50 p-8 rounded-2xl">
            Das ideale Umfeld, um sich ein starkes, flexibles Einkommen aufzubauen.
          </p>
        </div>
      </div>
    </section>
  );
}
